import { Flex } from "@chakra-ui/react";

import { NavigationBar } from "components/NavigationBar";
import { OFText } from "design_system/components/OFText";
import { RegionType } from "graphql/generated";
import { colors } from "src/colors";
import { PageEvents } from "src/dataTracking/events";
import { useTrackPageEvent } from "src/hooks/useTrackPageEvent";
import { checkCountry } from "src/utils/checkCountry";

import { CompleteYourHelpProfile } from "./CompleteYourHelpProfile";
import { GetStartedCard } from "./GetStartedCard";
import { Testimonials } from "./Testimonials";
import useGetStarted from "./useGetStarted";

type Props = {
  onClick(): void;
  evaluationId: string;
};
export const GetStarted = ({ evaluationId, onClick }: Props) => {
  const { reviews, cardData, start, back, t } = useGetStarted({ onClick, evaluationId });
  useTrackPageEvent(
    PageEvents.name.gettingStarted.replace("{eval_name}", evaluationId),
    PageEvents.categories.evaluation
  );

  return (
    <Flex flexDirection="column">
      <NavigationBar onClickBack={back} redirectToWebFlowWhenNotAuth />
      <Flex flexDirection="column" paddingBottom={["100px", "100px"]}>
        <Flex
          padding={["20px 20px 8px", "0 0 8px"]}
          flexDirection="column"
          width="100%"
          maxWidth="588px"
          margin="0 auto 34px"
          borderBottom="1px solid #F4BD98;"
        >
          <OFText
            marginBottom={["32px", "40px"]}
            marginTop={["24px", "40px"]}
            textStyle="h3"
            color={colors.black["900"]}
          >
            {t("get-started.title")}
          </OFText>

          {cardData.map((s) => (
            <GetStartedCard
              key={s.index}
              highlight={s.highlight}
              index={s.index}
              srcImage={s.srcImage}
              title={s.title}
              description={s.description}
              subTitle={s.subTitle}
              showDashLine={s.showDashLine}
            />
          ))}
        </Flex>

        {!checkCountry([RegionType.Jp]) && <Testimonials reviews={reviews} />}
      </Flex>

      <CompleteYourHelpProfile onClick={start} />
    </Flex>
  );
};
